module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dash-header"
    }
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": {
        name: 'home'
      },
      "title": "Link to Home"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeSidebarMobile()
      }
    }
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('b', [_vm._v(_vm._s(_vm.logoMini))])]), _vm._v(" "), _c('span', {
    staticClass: "logo-lg"
  }, [_c('img', {
    attrs: {
      "src": require("assets/logo.png")
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.header))])])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "data-toggle": "offcanvas",
      "role": "button",
      "title": "Show menu"
    },
    on: {
      "click": function($event) {
        _vm.toggleSidebar()
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])]), _vm._v(" "), _c('router-link', {
    staticClass: "sidebar-home-button",
    attrs: {
      "to": {
        name: 'home'
      },
      "title": "Link to Home"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeSidebarMobile()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-center"
  }, [_vm._v(_vm._s(_vm.subHeader))]), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_vm._l((_vm.allLang), function(value, index) {
    return [_c('li', {
      staticClass: "cursor-pointer pull-left nav-lang",
      class: {
        active: value === _vm.nowLang
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#FFF",
        "padding": "10px"
      },
      on: {
        "click": function($event) {
          _vm.switchLang(value)
        }
      }
    }, [_c('img', {
      staticClass: "img-language",
      staticStyle: {
        "padding-left": "0",
        "width": "30px",
        "margin-right": "-2px"
      },
      attrs: {
        "src": require('static/images/flag_' + _vm.focusLang(value) + '.png')
      }
    })])])]
  }), _vm._v(" "), (_vm.version >= '2.0.0') ? [_c('header-announce', {
    attrs: {
      "title": "Show announcement",
      "headerNotiAnnounceTotal": _vm.headerNotiAnnounceTotal,
      "headerNotiAnnounceInfiniteLoading": _vm.headerNotiAnnounceInfiniteLoading,
      "receivedHeaderNotiAnnounceInfiniteLoading": _vm.receivedHeaderNotiAnnounceInfiniteLoading,
      "numberFormat": _vm.numberFormat,
      "nowLang": _vm.nowLang
    }
  }), _vm._v(" "), _c('header-request', {
    attrs: {
      "title": "Show request",
      "headerNotiRequestTotal": _vm.headerNotiRequestTotal,
      "headerNotiRequestInfiniteLoading": _vm.headerNotiRequestInfiniteLoading,
      "receivedHeaderNotiRequestInfiniteLoading": _vm.receivedHeaderNotiRequestInfiniteLoading,
      "numberFormat": _vm.numberFormat,
      "nowLang": _vm.nowLang
    }
  }), _vm._v(" "), _c('header-approve', {
    attrs: {
      "title": "Show approve",
      "headerNotiApprove": _vm.headerNotiApprove,
      "numberFormat": _vm.numberFormat,
      "nowLang": _vm.nowLang
    }
  })] : _vm._e(), _vm._v(" "), _c('header-user', {
    attrs: {
      "title": "Show user profile",
      "currentUser": _vm.currentUser,
      "nowLang": _vm.nowLang,
      "version": _vm.version,
      "postLogout": _vm.postLogout,
      "profileimg": _vm.profileimg
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "title": "Setting"
    }
  }, [_c('a', {
    attrs: {
      "data-toggle": "control-sidebar"
    },
    on: {
      "click": function($event) {
        _vm.toggleControlsidebar(_vm.controlsidebarDisp)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })])])], 2)])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5bfafcd6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dash/DashHeader.vue
// module id = 3798
// module chunks = 1